export const setFAQChosenData = (value) => async dispatch => {
    dispatch({ type: 'SET_CHOSEN_DATA', choosenData: value });
}